import type { Employee } from 'src/api/EmployeeService';
import { useParams } from 'react-router';
import { useEmployeesEntry } from '@stores/employeeStore';

const useEmployees = (): {
    employees: Employee[] | undefined;
    departmentId: string | undefined;
    isLoadingEmployees: boolean;
    fetchEmployees: () => void;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const {
        response: employees,
        isLoading: isLoadingEmployees,
        requestApiCall: fetchEmployees,
    } = useEmployeesEntry(departmentId);

    return {
        employees,
        departmentId,
        isLoadingEmployees,
        fetchEmployees,
    };
};

export default useEmployees;
